"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var theme = {
  colors: {
    background: '#fff',
    border: '#ddd',
    title: '#005a9c',
    text: '#212121',
    link: '#005a9c'
  },
  shape: {
    borderRadius: '5px'
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
    fontSize: '10px',
    mobileFontSize: '8px'
  },
  overrides: {
    body: {
      fontSize: '1.6rem',
      lineHeight: '2.4rem',
      padding: '3.2rem'
    },
    h1: {
      fontSize: '3.6rem',
      margin: '3rem 0 4rem 0'
    },
    h2: {
      borderTop: '1px solid var(--borderColor)',
      fontSize: '3.2rem',
      margin: '7rem 0 3rem',
      padding: '1em 0 0 0'
    },
    h3: {
      fontSize: '2.4rem',
      margin: '5rem 0 1rem'
    },
    h4: {
      fontSize: '2rem',
      margin: '3rem 0 1rem'
    },
    h5: {
      fontSize: '1.6rem',
      margin: '2rem 0 1rem'
    },
    p: {
      fontSize: '1.6rem',
      margin: '0 0 1rem'
    },
    a: {
      fontSize: '1.6rem'
    }
  }
};

exports.generateOverrideStyles = function (themeOverrides) {
  var styles = [];

  for (var _i = 0, _a = Object.keys(themeOverrides); _i < _a.length; _i++) {
    var tag = _a[_i];
    var htmlTag = [];

    for (var _b = 0, _c = Object.keys(themeOverrides[tag]); _b < _c.length; _b++) {
      var cssProperty = _c[_b];
      var cssKey = cssProperty.replace(/([A-Z])/g, '-$1').toLowerCase();
      var value = themeOverrides[tag][cssProperty];
      var cssVar = "--" + tag + "_" + cssProperty;
      htmlTag.push({
        cssVar: cssVar + ": " + value + ";",
        cssProperty: cssKey + ": var(" + cssVar + ");"
      });
    }

    styles.push({
      htmlTag: tag,
      cssProperties: htmlTag
    });
  }

  return styles;
};

exports["default"] = theme;